import { render, staticRenderFns } from "./quantitativo.vue?vue&type=template&id=02b84470"
import script from "./quantitativo.vue?vue&type=script&lang=js"
export * from "./quantitativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports